import { ParmConstants } from "../types/parm";

export const PARM: ParmConstants = {
  URL: process.env.GUAC_PARM_URL,
  AUTO_PATH: process.env.GUAC_PARM_AUTO_PATH,
  PERM_PATH: process.env.GUAC_PARM_PERMISSIONS_PATH,
  ROLES_PATH: process.env.GUAC_PARM_ROLES_PATH,
  RELATIONSHIPS_PATH: process.env.GUAC_PARM_RELATIONSHIPS_PATH,
  ROLE_EXPIRATION_TIME: 70, // s
  DEFAULT_UPDATE_INTERVAL: 6000, //ms
};
